import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


const firebaseConfig: any = {
  apiKey: "AIzaSyCuc9dnlfVXomFmYWlNa9Je22ZC1kcc7ms",
  authDomain: "dev-team-pulse.firebaseapp.com",
  projectId: "dev-team-pulse",
  storageBucket: "dev-team-pulse.firebasestorage.app",
  messagingSenderId: "271687632763",
  appId: "1:271687632763:web:b32d3ba6d14c2493c81fde",
  measurementId: "G-8QX0VNYMZF"
};

const app = initializeApp(firebaseConfig);
console.log("Firebase initialized successfully");
const auth = getAuth(app);

export { auth, app };
